module.exports = __webpack_public_path__ + "static/img/1_0019.5d92c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0019.jpg
// module id = 4pdG
// module chunks = 0